import { ErrorMessage } from "formik";
import Select from "react-select";

const ClearIndicator = (props) => {
  const {
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles("clearIndicator", props)}
    ></div>
  );
};

const ClearIndicatorStyles = (base, state) => ({
  ...base,
  cursor: "pointer",
  // color: state.isFocused ? "#36C95F" : "black",
  control: (base, state) => ({
    ...base,
    // borderColor: "#84d8e2",
    boxShadow: "#c93636",
    borderRadius: "10px",
    height: "56px",
    // "&:hover": {
    //   borderColor: "#84d8e2",
    // },
    "&:focus-within": {
      borderColor: "#36C95F",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#36C95F" : "inherit",
    "&:hover": {
      backgroundColor: state.isSelected ? "#36C95F" : "rgb(222, 235, 255)",
    },
  }),
});

const CustomMultiSelect = ({
  field,
  form: { touched, errors, setFieldValue },
  label,
  isMulti,
  required,
  placeholder,
  onChange,
  options,
  menuStyles,
  noMarginBottom,
  ...props
}) => {
  let values = [];
  if (isMulti === true && Array.isArray(field?.value)) {
    values =
      options?.filter(({ value }) =>
        field?.value?.some((option) => option.value === value)
      ) ?? [];
  } else {
    values = options.find((option) => option.value === field.value) ?? [];
  }
  return (
    <div className={`${noMarginBottom == true ? "" : "mb-2"}`}>
      <label className="mb-1">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <Select
        {...field}
        {...props}
        closeMenuOnSelect={false}
        options={options}
        components={{ ClearIndicator }}
        // styles={{ clearIndicator: ClearIndicatorStyles }}
        value={values}
        placeholder={placeholder}
        isClearable={true}
        // classNamePrefix={`select2 select-${field.name}`}
        classNamePrefix={`select2 select2-`}
        onChange={(event) => {
          if (props.isDisabled) return; //if select is disabled, do nothing
          if (onChange) {
            onChange(event);
          } else {
            if (isMulti === true) {
              // setFieldValue(field.name, event ?? [])
              setFieldValue(field.name, event ?? []);
            } else {
              // setFieldValue(field.name, event?.value ?? null)
              setFieldValue(field.name, event?.value ?? "");
            }
          }
        }}
        className={`${
          !!touched[field.name] && !!errors[field.name] && "border-danger"
        }`}
        isMulti={isMulti === true}
        styles={{
          menu: (css) => ({
            ...css,
            width: "max-content", //open menu options in full width
            minWidth: "100%", //open menu options in 100% when not required full width
            zIndex: 2,
            ...menuStyles, //when menu option going off screen pass {position: "absolute", right: 0}
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? "#18a594"
              : state.isFocused
              ? "rgb(222, 235, 255)"
              : "inherit",
            "&:hover": {
              backgroundColor: state.isSelected
                ? "#18a594"
                : "rgb(222, 235, 255)",
            },
          }),
          control: (css) => ({
            ...css,
            minWidth: "100%",
            minHeight: "2.2rem",
            padding: "0rem 0.4rem",
            fontSize: "0.86563rem",
            borderRadius: "0.3rem",
            //height: "calc(1.5em + 0.5rem + 6px)",
            // borderColor: "#84d8e2",
            boxShadow: "#c93636",
            // "&:hover": {
            //   borderColor: "#84d8e2",
            // },
            "&:focus-within": {
              borderColor: "#18a594",
            },
          }),
          container: (css) => ({
            ...css,
            padding: "0",
            fontSize: "0.86563rem",
          }),
          valueContainer: (css) => ({
            ...css,
            padding: "0",
          }),
          dropdownIndicator: (css) => ({
            ...css,
            padding: "0",
            width: "16px",
            marginLeft: "1px",
          }),
          clearIndicator: ClearIndicatorStyles,
          indicatorsContainer: (css) => ({
            ...css,
            paddingRight: "0",
          }),
        }}
      />
      <ErrorMessage
        name={field.name}
        component="div"
        className="invalid-feedback animated fadeInUp"
        style={{ display: "block" }}
      />
    </div>
  );
};

export default CustomMultiSelect;
